<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ff4081" type="timer" [fullScreen]="true">
    <p style="color: white">Loading...</p>
</ngx-spinner>
<div *ngIf="userService.orgCd != null && userService.orgCd != undefined" class="dashboard-container">
    <!-- Header Section -->
    <div class="header-card" #bucketsSection>
        <div class="header-content">
            <div class="title-container">
                <ng-container *ngIf="userService.resourceRole?.toLowerCase() === 'contractor' 
                    && userService.ImageLogo === 'Yes'">
                    <img src="assets/DOM1/participating_contract.png" alt="Participating Contractor"
                        class="dashboard-icon" />
                </ng-container>
                <div class="dashboard-title">Dashboard</div>
            </div>

            <!-- Program Filter -->
            <div *ngIf="isDataLoaded">
                <mat-form-field id="program-form-filter">
                    <mat-label>Programs</mat-label>
                    <mat-select [formControl]="formPrograms" multiple>
                        <mat-option *ngFor="let program of programs" [value]="program.name">
                            {{ program.description }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <button mat-flat-button color="primary" (click)="clearProgramFilters()"
                    class="program-filter-btn">CLEAR</button>
                <button mat-flat-button color="primary" (click)="applyProgramFilters()"
                    class="program-filter-btn">APPLY</button>
            </div>

            <!-- Date Picker Section -->
            <div class="date-picker-container">
                <ng-container
                    *ngIf="userService.resourceRole?.toLowerCase() === 'admin' || userService.resourceRole?.toLowerCase() === 'csr'">                    
                    <app-date-picker [fromDate]="fromDate" [toDate]="toDate" [programs]="dashboardPrograms"
                        [selectedProgram]="selectedProgram" (dateChange)="onDateChanges($event)"></app-date-picker>                      
                </ng-container>
            </div>
        </div>
    </div>

    <!-- Buckets Section for Admin -->
    <div class="buckets-container"
        *ngIf="userService.resourceRole?.toLowerCase() == 'admin' || userService.resourceRole?.toLowerCase() == 'csr'">
        <div class="bucket-card" *ngFor="let item of buckets" [style.background]="item.Background"
            [ngClass]="{'total-bucket': item.label == 'Total Workorders'}"
            (click)="item.label != 'Total Workorders' ? applyFilterAndScroll(item.WorkorderStatus, workordersSection) : refrehPage(workordersSection)">
            <mat-icon [style.color]="item.Color">{{ item.Icon }}</mat-icon>
            <h3 class="admin-bucket-label" [style.color]="item.Color">{{ item.label }}</h3>
            <div class="admin-bucket-count" [style.color]="item.Color">
                {{ item.Count }}
            </div>
        </div>
    </div>

    <!-- Buckets Section for Non-Admin -->
    <div class="buckets-row"
        *ngIf="userService.resourceRole?.toLowerCase() == 'contractor' || userService.resourceRole?.toLowerCase() == 'distributor'">
        <div class="bucket-column" *ngFor="let item of buckets"
            (click)="applyFilterAndScroll(item.WorkorderStatus, workordersSection)">
            <div class="left-border" [style.background]="item.Background"></div>
            <div class="bucket-content">
                <mat-icon class="bucket-icon">{{ item?.Icon }}</mat-icon>
                <div class="bucket-count">{{ item.Count }}</div>
                <h5 class="nonAdmin-bucket-label" [style.color]="item.Color">{{ item.label }}</h5>
            </div>
        </div>
    </div>

    <!-- Matrix Table -->
    <div class="table-card matrix-table-container" *ngIf="dataMatrix.length > 0">
        <table class="matrix-table all-border">
            <thead>
                <tr>
                    <th class="matrix-header-cell" *ngFor="let head of dataMatrix[0] | keyvalue : originalOrder">
                        {{ head.key }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of dataMatrix">
                    <td class="matrix-cell" *ngFor="let list of item | keyvalue : originalOrder">
                        <span
                            (click)="list.key != 'WorkorderType' ? applyFilter(item, list.key, true, workordersSection) : applyFilter(item, '', true, workordersSection)">
                            {{ item[list.key] }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Workorders Table -->
    <div class="table-card" #workordersSection>
        <div class="table-header">
            <h2 class="table-title">Workorders</h2>
            <button mat-flat-button color="primary" class="reset-btn" (click)="refrehPage(null)">RESET FILTERS</button>
        </div>
        <mat-divider style="margin-bottom: 10px;"></mat-divider>
        <table mat-table [dataSource]="dataSource" matSort class="workorder-table">
            <!-- Workorder ID -->
            <ng-container matColumnDef="WorkorderID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Workorder ID
                    <button mat-button class="filter-btn" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                        matRipple="false">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                    <mat-menu #menu>
                        <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Workorder ID
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <mat-form-field>
                                <input matInput class="form-field" [formControl]="workorderIDFilter"
                                    placeholder="Filter">
                            </mat-form-field>
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <button mat-raised-button (click)="clearColumn('workorderIDFilter')"
                                color="primary">Clear</button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.WorkorderID }}</td>
            </ng-container>

            <!-- Workorder Type -->
            <ng-container matColumnDef="WorkorderType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Workorder Type
                    <button mat-button class="filter-btn" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                        matRipple="false">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                    <mat-menu #menu>
                        <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Workorder Type
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <mat-form-field>
                                <input matInput class="form-field" [formControl]="workorderTypeFilter"
                                    placeholder="Filter">
                            </mat-form-field>
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <button mat-raised-button (click)="clearColumn('workorderTypeFilter')"
                                color="primary">Clear</button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let workorder" matTooltip="{{ workorder.WorkorderType }}">{{
                    workorder.WorkorderType }}</td>
            </ng-container>

            <!-- Account Holder -->
            <ng-container matColumnDef="AccountHolder">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Account Holder
                    <button mat-button class="filter-btn" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                        matRipple="false">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                    <mat-menu #menu>
                        <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Account Holder
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <mat-form-field>
                                <input matInput class="form-field" [formControl]="accountHolderFilter"
                                    placeholder="Filter">
                            </mat-form-field>
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <button mat-raised-button (click)="clearColumn('accountHolderFilter')"
                                color="primary">Clear</button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let workorder" matTooltip="{{ workorder.AccountHolder }}">{{
                    workorder.AccountHolder }}</td>
            </ng-container>

            <!-- Distributor -->
            <ng-container matColumnDef="Distributor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Distributor
                    <button mat-button class="filter-btn" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                        matRipple="false">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                    <mat-menu #menu>
                        <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Distributor
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <mat-form-field>
                                <input matInput class="form-field" [formControl]="distributorFilter"
                                    placeholder="Filter">
                            </mat-form-field>
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <button mat-raised-button (click)="clearColumn('distributorFilter')"
                                color="primary">Clear</button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let workorder" matTooltip="{{ workorder.Distributor }}">{{
                    workorder.Distributor }}</td>
            </ng-container>

            <!-- Contractor -->
            <ng-container matColumnDef="Contractor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Contractor
                    <button mat-button class="filter-btn" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                        matRipple="false">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                    <mat-menu #menu>
                        <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Contractor
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <mat-form-field>
                                <input matInput class="form-field" [formControl]="contractorFilter"
                                    placeholder="Filter">
                            </mat-form-field>
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <button mat-raised-button (click)="clearColumn('contractorFilter')"
                                color="primary">Clear</button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let workorder" matTooltip="{{ workorder.Contractor }}">{{
                    workorder.Contractor
                    }}</td>
            </ng-container>

            <!-- Workorder Status -->
            <ng-container matColumnDef="WorkorderStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Workorder Status
                    <button mat-button class="filter-btn" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                        matRipple="false">
                        <mat-icon>filter_alt</mat-icon>
                    </button>
                    <mat-menu #menu>
                        <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">Workorder
                            Status
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <mat-form-field>
                                <input matInput class="form-field" [formControl]="workorderStatusFilter"
                                    placeholder="Filter">
                            </mat-form-field>
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <button mat-raised-button (click)="clearColumn('workorderStatusFilter')"
                                color="primary">Clear</button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let workorder" matTooltip="{{ workorder.WorkorderStatus }}">{{
                    workorder.WorkorderStatus }}</td>
            </ng-container>

            <!-- Updated -->
            <ng-container matColumnDef="Updated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated Date
                    <button mat-button class="filter-btn" [matMenuTriggerFor]="updatedMenu"
                        (click)="$event.stopPropagation()">
                        <mat-icon>filter_alt</mat-icon>
                    </button>

                    <mat-menu #updatedMenu>
                        <div mat-menu-item mat-filter-item [disableRipple]="true" class="menu-title">
                            Updated Date
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <mat-form-field>
                                <input matInput [formControl]="updatedFilter" placeholder="Filter">
                            </mat-form-field>
                        </div>
                        <div mat-menu-item mat-filter-item [disableRipple]="true">
                            <button mat-raised-button color="primary" (click)="clearColumn('updatedFilter')">
                                Clear
                            </button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell *matCellDef="let workorder">{{ workorder.Updated | date:'shortDate' }}</td>
            </ng-container>

            <!-- Details -->
            <ng-container matColumnDef="Details">
                <th mat-header-cell *matHeaderCellDef style="width: 6% !important">Details</th>
                <td mat-cell *matCellDef="let workorder">
                    <button mat-button (click)="handleEnrollmentWorkorderClick(workorder, workorder.EnrollmentId)">
                        <mat-icon style="visibility: visible; color: #3CB371;">label_important</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[100, 200, 300, 400, 500]" showFirstLastButtons></mat-paginator>
        <button mat-fab class="scroll-to-top"
            (click)="scrollToBuckets(bucketsSection)"><mat-icon>arrow_upward</mat-icon></button>
    </div>
</div>